<div>
	<iframe style="width: 100%;height: 1000px; border: 0" [src]="workshopUrl" crossorigin="anonymous"></iframe>
</div>
